/**
 * Column class
 * @private
 */
/* eslint-disable */
export class Column {
}
